import React from "react";
import type { PreviewSplitLayoutProps } from "./PreviewSplitLayout.types";
import { Column, Layout, StickyColumn } from "./PreviewSplitLayout.styles";

/** Controls on the left, a preview on the right that stays in view while the controls scroll; one column under 48rem. */
export const PreviewSplitLayout: React.FC<PreviewSplitLayoutProps> = ({ controls, preview, className }) => (
  <Layout className={className}>
    <Column>{controls}</Column>
    <StickyColumn>{preview}</StickyColumn>
  </Layout>
);

export default PreviewSplitLayout;
